/**
 * Formats dashboard filters into a stringified JSON payload for the API.
 * @param {Object} filters - Object containing the filter states
 * @returns {Object} Prepared data payload
 */
export const generateFetchDataPayload = (filters) => {
    const format = (filter) =>
        JSON.stringify(filter?.newValue?.length > 0 ? filter.newValue : []);

    return {
        globalIntake: format(filters.filterIntake),
        globalSchool: format(filters.filterSchool),
        globalLearningMethod: format(filters.filterLearningMethod),
        globalLecturer: format(filters.filterLecturer)
    };
};

/**
 * Util function to get a class name to apply to the amount of digits for notifications.
 * @param {number} value Amount to apply class to.
 * @returns Class-Name
 */
/** Coerce API count values; reject SQL/error objects returned as 200 payloads. */
export function toSafeCount(value) {
    return typeof value === "number" && Number.isFinite(value) ? value : null;
}

export function getDigitClass(value) {
    if (!value) {
        return "";
    } else if (value > 999 && value < 10000) {
        return "four-digit";
    } else if (value > 9999 && value < 100000) {
        return "five-digit";
    } else if (value > 99 && value < 1000) {
        return "three-digit";
    }
    return "";
};
